import * as React from 'react'
import Layout from '../components/layout'

const AboutPage = () => {
    return (
        <Layout pageTitle="About">
            <p>Hi, im Chriss and this is a page about me!</p>
        </Layout>
    )
}

export default AboutPage